import { Link, useSearchParams } from "react-router-dom";
import { CheckCircle2 } from "lucide-react";
import PublicLayout from "@/components/layout/PublicLayout";
import { Button } from "@/components/ui/button";

export default function VoorBedrijvenBedankt() {
  const [params] = useSearchParams();
  return (
    <PublicLayout>
      <section className="oc-section">
        <div className="oc-container max-w-xl text-center">
          <div className="w-16 h-16 rounded-full bg-oc-fair/15 flex items-center justify-center mx-auto">
            <CheckCircle2 className="w-8 h-8 text-oc-fair" />
          </div>
          <h1 className="font-display font-bold text-[34px] text-oc-primary mt-5">Bedankt voor je aanmelding!</h1>
          <p className="text-oc-textSecondary text-[15px] mt-3 leading-relaxed">
            Je betaling wordt verwerkt door MultiSafepay. Eens ontvangen, controleren wij je gegevens en activeren we je profiel binnen 1 werkdag. Je ontvangt een bevestigingsmail.
          </p>
          {params.get("id") && (
            <p className="text-[13px] text-oc-textSecondary mt-4">Referentie: <span className="font-mono">{params.get("id")}</span></p>
          )}
          <Link to="/">
            <Button className="mt-7 bg-oc-primary hover:bg-oc-secondary text-white rounded-oc-btn h-12 px-7">Terug naar home</Button>
          </Link>
        </div>
      </section>
    </PublicLayout>
  );
}
